/* eslint-disable no-lone-blocks */
import { Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import AutoCard from 'components/AutoCard';
import i18n from 'i18n';
import { getMonthlyEnvironmentsCostMonitorGraphRequest } from 'modules/monitor/actions';
import React from 'react';
import { connect } from 'react-redux';
import MonthlyEnvironmentsCardGraphContent from './MonthlyEnvironmentsCostGraphContent';
import styles, { overrideCardGraph } from './styles';

interface MonthlyEnvironmentsCostCardProps {
  getMonthlyEnvironmentsCostMonitorGraphRequest: () => void;
}

const EnvironmentsCostCard = ({
  getMonthlyEnvironmentsCostMonitorGraphRequest,
}: MonthlyEnvironmentsCostCardProps) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles({});
  const { breakpoints } = useTheme();

  React.useEffect(() => {
    getMonthlyEnvironmentsCostMonitorGraphRequest();
  }, [getMonthlyEnvironmentsCostMonitorGraphRequest]);

  return (
    <Grid item className={classes.environmentsCostContainer}>
      <Grid container justify="flex-start" style={{ marginBlock: '8px' }}>
        <Typography className={classes.titleCard}>
          {i18n.t('ADVISOR_PAGE.MONTHLY_ENVIRONMENTS_COST_TITLE_KEY')}
        </Typography>
      </Grid>
      <Grid item className={classes.containerCard}>
        <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
          <Grid container>
            <Grid container className={classes.containerGraph}>
              <Grid item xs={12}>
                <MonthlyEnvironmentsCardGraphContent />
              </Grid>
            </Grid>
          </Grid>
        </AutoCard>
      </Grid>
    </Grid>
  );
};

export default connect(null, {
  getMonthlyEnvironmentsCostMonitorGraphRequest,
})(EnvironmentsCostCard);
